import * as React from 'react';
import { cn } from '@/lib/utils';


export const themeCardClass =
  'rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-[0_1px_2px_rgba(16,24,40,0.04)] ' +
  'transition duration-200 hover:border-[#D0D5DD] hover:shadow-[0_4px_12px_rgba(16,24,40,0.08)]';

export const THEME_TITLE_SIZE = {
  sm: 'text-[13px]',
  smPlus: 'text-[13.5px]',
  md: 'text-[14px]',
  lg: 'text-[15px]',
  xl: 'text-[16px]',
} as const;

export type ThemeTitleSize = keyof typeof THEME_TITLE_SIZE;

export function ThemeCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn(themeCardClass, className)}>{children}</div>;
}

export function MenuBtn({ label = 'More' }: { label?: string }) {
  return (
    <button
      type="button"
      className="h-8 w-8 inline-flex items-center justify-center rounded-lg text-[#9CA3AF] hover:bg-[#F3F4F6] hover:text-[#374151] transition"
      aria-label={label}
    >
      <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden>
        <circle cx="4" cy="10" r="1.5" />
        <circle cx="10" cy="10" r="1.5" />
        <circle cx="16" cy="10" r="1.5" />
      </svg>
    </button>
  );
}
